import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { md5 } from "js-md5";

import { checkQueryParams } from "./functions/checkQueryParams";
import { getHexRemainder } from "./functions/getHexRemainder";

import type { ABTestGroup } from "./types/ABTestGroup";

// ABテストのグループ名のシード. ABテストを追加する際には、ABテストごとにtypeを追加する
type ABTestWithUserIdSeed =
  | "AB_TEST_PLAYER_BUFFER_DURATION"
  | "AB_TEST_ABR_STRATEGY";

export const enableABTestWithUserId = (
  abTestSeed: ABTestWithUserIdSeed
): boolean => {
  try {
    // URLパラメータにab_test_groupが指定されている場合は、その値で機能を出すかどうかを判定する
    const queryParamsGroup = checkQueryParams();
    if (queryParamsGroup !== undefined) {
      return queryParamsGroup === "B_GROUP";
    }
    const userId = firebase.auth()?.currentUser?.uid;
    if (userId === undefined) {
      return false;
    }

    const abTestGroup = getABTestGroupWithUserId(abTestSeed, userId);
    if (abTestGroup === undefined) {
      return false;
    }

    return abTestGroup === "B_GROUP";
  } catch (e) {
    console.error(e);
    return false;
  }
};

const getABTestGroupWithUserId = (
  abTestSeed: ABTestWithUserIdSeed,
  userId: string
): ABTestGroup => {
  // userIdを用いてABテストのグループを決定する
  // テストに記載してあるBQでの集計用のSQLと同じロジックを用いる
  const hash = md5.create();
  hash.update(abTestSeed + userId);
  const hexDigest = hash.hex();

  return getHexRemainder(hexDigest);
};
